function RTACheck() {
	var rtaCookie = Utils.getCookie("rta_terms_accepted");
	var isDocumentsPage = /\/documents\//.test(window.location.href);

	//Is "TV" and "Tizen"
	function isTizenOnTv() {
		const result = navigator.userAgent.search(/TV/i) >= 0 && navigator.userAgent.search(/Tizen/i) >= 0;
		return result;
	}

	const videoContainerElement = document.querySelector(".video-container");

	function setContentVisibility(show) {
		const rtaHiddenElement = document.querySelector(".rta-hidden");

		if (rtaHiddenElement) {
			rtaHiddenElement.style.display = show ? "block" : "none";
		}

		if (videoContainerElement && show) {
			videoContainerElement.style.display = "block";
			initPlayer();
		}
	}

	if (!rtaCookie && !isDocumentsPage && !isTizenOnTv()) {
		setContentVisibility(false);

		swal.fire({
			html: RTAData.content,
			titleText: RTAData.title,
			allowOutsideClick: false,
			allowEscapeKey: false,
			confirmButtonText: RTAData.confirmButtonText,
			customClass: "RTAModal",
			footer:
				'<div class="document-page-footer"><a href="' +
				RTAData.parentalControlUrl +
				'">' +
				RTAData.parentalControlText +
				"</a></div>",
		}).then(function () {
			Utils.setCookie("rta_terms_accepted", true, Utils.getDays(180), Utils.getDomain(), {
				secure: true,
				sameSite: "Lax",
			});
			setRTABlur(0);
			setContentVisibility(true);
		});
	} else {
		document.addEventListener("DOMContentLoaded", function (event) {
			setRTABlur(0);
			setContentVisibility(true);
		});
	}
}

document.addEventListener("DOMContentLoaded", function (event) {
	RTACheck();
});
